import { render, staticRenderFns } from "./BCXProgressDots.vue?vue&type=template&id=bb8797d6&scoped=true"
import script from "./BCXProgressDots.vue?vue&type=script&lang=ts"
export * from "./BCXProgressDots.vue?vue&type=script&lang=ts"
import style0 from "./BCXProgressDots.vue?vue&type=style&index=0&id=bb8797d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8797d6",
  null
  
)

export default component.exports